import type { PostCard } from '../types'

export function shouldRenderMicroCard(post: Pick<PostCard, 'format'> | null | undefined): boolean {
  return String(post?.format || '').toLowerCase() === 'micro'
}

export function formatWatermarkLabel(format: string | null | undefined): string | null {
  const value = String(format || '').toLowerCase()
  if (!value) return 'PIXE • ZINE'
  if (value === 'micro') return 'PIXE • MICRO'
  if (value === 'zine') return 'PIXE • ZINE'
  if (value === 'event') return 'PIXE • EVENT'
  if (value === 'job') return 'PIXE • JOB'
  return null
}
